module.exports = __webpack_public_path__ + "media/assets/icons/beauty-salon-6e6df9556476a2f3fd4b88607a457f48.svg";